// Pendaftaran service worker (PWA), tombol "Pasang aplikasi", dan tawaran
// pasang yang muncul sendiri bersama pemberitahuan "siap tanpa internet".
import { registerSW } from 'virtual:pwa-register';
import { toast } from './modal.js';
import { $ } from '../core/dom.js';
import { store } from '../core/storage.js';
import { MODE_DEMO } from './riwayat.js';

const KUNCI_NANTI = 'tka_pasang_nanti';
const JEDA_NANTI = 3 * 24 * 3600 * 1000; // "Nanti" = jangan tawarkan lagi selama 3 hari

let promptPasang = null;
let siapOffline = false;
let sudahDitawarkan = false;
const tombolList = new Set();
const segarkan = () => tombolList.forEach(b => { b.hidden = !promptPasang; });

const sudahTerpasang = () =>
  window.matchMedia?.('(display-mode: standalone)').matches || window.navigator.standalone === true;
// Safari di iPhone/iPad tidak punya beforeinstallprompt; pemasangan lewat menu Bagikan.
const iosSafari = () => {
  const ua = navigator.userAgent;
  const ios = /iPad|iPhone|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  return ios && /Safari/.test(ua) && !/CriOS|FxiOS|EdgiOS/.test(ua);
};
const sedangKuis = () => !$('#scr-quiz').hidden;
const sedangJeda = () => Date.now() - (+store.get(KUNCI_NANTI, 0) || 0) < JEDA_NANTI;

async function pasang() {
  if (!promptPasang) return;
  const p = promptPasang;
  promptPasang = null; segarkan();
  p.prompt();
  const { outcome } = await p.userChoice;
  if (outcome !== 'accepted') store.set(KUNCI_NANTI, Date.now());
}

// Satu toast saja: kabar siap offline sekaligus tawaran pasang bila bisa.
function tawarkan() {
  const awal = siapOffline ? 'Aplikasi siap dipakai tanpa internet.' : 'Kuis Juara TKA bisa dipasang dan dibuka tanpa internet.';
  const bolehTawar = !sudahDitawarkan && !sudahTerpasang() && !sedangJeda() && !sedangKuis();
  const nanti = () => store.set(KUNCI_NANTI, Date.now());
  if (bolehTawar && promptPasang) {
    sudahDitawarkan = true;
    toast(`${awal} Pasang di layar utama supaya bisa dibuka seperti aplikasi?`,
      { aksi: pasang, labelAksi: 'Pasang', labelTutup: 'Nanti', onTutup: nanti, lama: 0 });
  } else if (bolehTawar && iosSafari()) {
    sudahDitawarkan = true;
    toast(`${awal} Untuk memasang: ketuk tombol <b>Bagikan</b> lalu pilih <b>Tambah ke Layar Utama</b>.`,
      { labelTutup: 'Nanti', onTutup: nanti, lama: 15000 });
  } else if (siapOffline && !sudahDitawarkan) {
    toast('Aplikasi siap dipakai tanpa internet.');
  }
}

export function initPWA() {
  if (MODE_DEMO) return;
  const update = registerSW({
    onNeedRefresh() {
      // Jangan muat ulang otomatis: anak mungkin sedang mengerjakan soal.
      toast(sedangKuis() ? 'Versi baru tersedia. Muat ulang setelah kuis selesai.' : 'Versi baru aplikasi tersedia.', { aksi: () => update(true), labelAksi: 'Muat ulang', lama: 0 });
    },
    onOfflineReady() {
      siapOffline = true;
      // beforeinstallprompt bisa datang sedikit setelahnya; tunggu sebentar
      // supaya kabar offline dan tawaran pasang tampil dalam satu toast.
      if (promptPasang) tawarkan();
      else setTimeout(() => { if (!sudahDitawarkan) tawarkan(); }, 2500);
    },
  });
  window.addEventListener('beforeinstallprompt', e => {
    e.preventDefault();
    promptPasang = e; segarkan();
    // Kunjungan berikutnya (service worker sudah terpasang): tetap tawarkan sekali.
    if (!sudahDitawarkan) setTimeout(() => { if (!sudahDitawarkan && promptPasang) tawarkan(); }, siapOffline ? 0 : 1500);
  });
  window.addEventListener('appinstalled', () => { promptPasang = null; segarkan(); store.del(KUNCI_NANTI); toast('Aplikasi berhasil dipasang.'); });
}

export function tombolPasang(btn) {
  if (!btn || tombolList.has(btn)) { segarkan(); return; }
  tombolList.add(btn);
  btn.onclick = pasang;
  segarkan();
}
